// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2xXsh","vLegacy":"SelectSecondary_vLegacy__1ndWB","error":"SelectSecondary_error__210vK","disabled":"SelectSecondary_disabled__2qhp-"};